module.exports = __webpack_public_path__ + "static/media/fire-station.b699d1e8.svg";